import React from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { MdDelete } from "react-icons/md";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setFITTransportDeleteIndex } from "./FITBookingSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import { IVehicleType } from "../vehicletype/vehicletypeModel";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import IconButton from "../../components/common/IconButton";
import { ICurrency } from "../currency/currencyModel";
import { ICity } from "../city/cityModel";

const FITBookingTransportArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const FITTransportDeleteIndex = useAppSelector(
    (state) => state.FITBooking.FITTransportDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const CurrencyList = useAppSelector((state) => state.currency.CurrencyList);
  const VehicleTypeList = useAppSelector(
    (state) => state.vehicleType.VehicleTypeList
  );
  const CityList = useAppSelector((state) => state.city.CityList);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("fitTransportDeleteDialog"));
    dispatch(setFITTransportDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setFITTransportDeleteIndex(-1));
      if (
        !fieldArrayRenderProps.value ||
        fieldArrayRenderProps?.value?.length <= 1
      ) {
        fieldArrayRenderProps?.formRenderProps.onChange("DriverAllowance", {
          value: 0,
        });
        fieldArrayRenderProps?.formRenderProps.onChange("TotalTax", {
          value: 0,
        });
        fieldArrayRenderProps?.formRenderProps.onChange(
          "TransportaionCurrencyID",
          {
            value: 1,
          }
        );
        fieldArrayRenderProps?.formRenderProps.onChange(
          "TransportaionConversionRate",
          {
            value: 1,
          }
        );
      }
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        VehicleTypeID: null,
        Place: "",
        FromDate: "",
        ToDate: "",
        Rate: null,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {/* {!fieldArrayRenderProps.value || fieldArrayRenderProps?.value?.length < 1
        ? pushElementInarray()
        : null} */}

      <GridLayoutItem
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "start",
          }}
        >
          <Field
            id={"TransportaionCurrencyID"}
            name={"TransportaionCurrencyID"}
            label={"Currency"}
            placeholder="Currency"
            component={FormSelectionField}
            validator={
              fieldArrayRenderProps.value &&
              fieldArrayRenderProps?.value?.length > 0
                ? requiredValidator
                : skipValidator
            }
            astrike={
              fieldArrayRenderProps.value &&
              fieldArrayRenderProps?.value?.length > 0
            }
            onChange={(e) => {
              if (e?.value) {
                const conversionRate =
                  CurrencyList.find(
                    (currency: ICurrency) => currency.ID === e?.value
                  )?.CurrencyConversion || "1";

                fieldArrayRenderProps?.formRenderProps.onChange(
                  "TransportaionConversionRate",
                  {
                    value: +conversionRate,
                  }
                );
              } else {
                fieldArrayRenderProps?.formRenderProps.onChange(
                  "TransportaionConversionRate",
                  {
                    value: 1,
                  }
                );
              }
            }}
            options={CurrencyList?.map((currency: ICurrency) => {
              return {
                value: currency.ID,
                label: currency.CurrencyName,
              };
            })}
          />
          <Field
            wrapperClassName="right-aligned-field"
            name="TransportaionConversionRate"
            label="Conversion Rate"
            placeholder="0"
            component={FormNumericTextField}
            disabled={
              !fieldArrayRenderProps.value ||
              fieldArrayRenderProps?.value?.length < 1
            }
            validator={
              fieldArrayRenderProps.value &&
              fieldArrayRenderProps?.value?.length > 0
                ? requiredValidator
                : skipValidator
            }
            astrike={
              fieldArrayRenderProps.value &&
              fieldArrayRenderProps?.value?.length > 0
            }
            min={0}
          />
          <Field
            wrapperClassName="right-aligned-field"
            name="DriverAllowance"
            label="Driver Allowance"
            placeholder="0"
            component={FormNumericTextField}
            disabled={
              !fieldArrayRenderProps.value ||
              fieldArrayRenderProps?.value?.length < 1
            }
            // validator={
            //   fieldArrayRenderProps.value &&
            //   fieldArrayRenderProps?.value?.length > 0
            //     ? requiredValidator
            //     : skipValidator
            // }
            min={0}
          />
          <Field
            wrapperClassName="right-aligned-field"
            name="TotalTax"
            label="Toll Tax"
            placeholder="0"
            component={FormNumericTextField}
            disabled={
              !fieldArrayRenderProps.value ||
              fieldArrayRenderProps?.value?.length < 1
            }
            // validator={
            //   fieldArrayRenderProps.value &&
            //   fieldArrayRenderProps?.value?.length > 0
            //     ? requiredValidator
            //     : skipValidator
            // }
            min={0}
          />
          <Field
            wrapperClassName="right-aligned-field"
            name="TransportMarkup"
            label="Transport Markup"
            placeholder="0"
            component={FormNumericTextField}
            min={0}
          />
        </div>
        {(!fieldArrayRenderProps.value ||
          fieldArrayRenderProps?.value?.length < 1) && (
          <div>
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={pushElementInarray}
              type="button"
              style={{ marginTop: 35 }}
            >
              Add Transport
            </Button>
          </div>
        )}
      </GridLayoutItem>
      {dialogName === "fitTransportDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Transport"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(FITTransportDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (Transportations: any, index: number) => (
            <GridLayoutItem key={index}>
              <Card className="fieldarray-card">
                <GridLayout
                  style={{ marginRight: 25 }}
                  gap={{ rows: 0, cols: 5 }}
                  cols={[
                    { width: "20%" },
                    { width: "20%" },
                    { width: "19%" },
                    { width: "19%" },
                    { width: "17%" },
                    { width: "5%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.VehicleTypeID`}
                      label="Vehicle Type"
                      placeholder="Vehicle Type"
                      component={FormSelectionField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                      isAddNew={true}
                      isIndirect={true}
                      drawerName="vehicletypeForm"
                      options={VehicleTypeList?.map(
                        (vehicletype: IVehicleType) => {
                          return {
                            value: vehicletype?.ID,
                            label: vehicletype?.VehicleType,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  {/* <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.Place`}
                      label="Place"
                      placeholder="Place"
                      component={FormTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem> */}
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.PlaceID`}
                      id={"PlaceID"}
                      label={"City"}
                      placeholder="i.e. Ahmedabad"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={CityList?.map((city: ICity) => {
                        return {
                          value: city?.ID,
                          label: city?.CityName || "",
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.FromDate`}
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      minDate={moment().toDate()}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.ToDate`}
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={
                        fieldArrayRenderProps.formRenderProps.valueGetter(
                          `Transportations.${index}.FromDate`
                        )
                          ? moment(
                              fieldArrayRenderProps.formRenderProps.valueGetter(
                                `Transportations.${index}.FromDate`
                              )
                            ).toDate()
                          : moment().toDate()
                      }
                      component={FormDatePicker}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field"
                      name={`Transportations.${index}.Rate`}
                      label="Rate"
                      placeholder="0"
                      min={0}
                      component={FormNumericTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="text-end">
                    <IconButton
                      onClick={() => handleOpenDeleteDialog(index)}
                      // disabled={fieldArrayRenderProps.value.length === 1}
                      themeColor={"error"}
                      size={"small"}
                      fillMode={"solid"}
                      type="button"
                      style={{
                        height: 30,
                        width: 30,
                        marginTop: 35,
                      }}
                      icon={MdDelete}
                      iconClassName="absolute-position"
                      iconStyle={{ fontSize: "16px" }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </Card>
            </GridLayoutItem>
          )
        )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps?.value?.length > 0 && (
          <GridLayoutItem style={{ textAlign: "end" }}>
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={pushElementInarray}
              type="button"
            >
              Add Transport
            </Button>
          </GridLayoutItem>
        )}
    </GridLayout>
  );
};

export default FITBookingTransportArray;
